import { useAuthProvider } from "../providers/auth.provider";

export function useAPI() {
  const [{ api }] = useAuthProvider();
  return api;
}
